import { isRSAA, RSAA } from 'redux-api-middleware';
import configSelectors from '../config';
import { getRequestHeader } from '../../utils/ConfigurationDetails';

const apiUrlMiddleware = (store) => (next) => (action) => {
  if (!isRSAA(action)) {
    return next(action);
  }
  const storeState = store.getState();

  const accessToken = configSelectors.accessToken(storeState);

  const urlSelectors = {
    bank_id: configSelectors.bankId,
    PAASBaseUrl: configSelectors.apiBaseUrlPAAS,
  };

  const endpoint = Object.keys(urlSelectors).reduce(
    (curEndpoint, selectorKey) =>
      curEndpoint.replace(selectorKey, urlSelectors[selectorKey](storeState)),
    action[RSAA].endpoint
  );

  const headers = getRequestHeader(storeState);

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }
  const req = {
    ...action,
    [RSAA]: {
      ...action[RSAA],
      headers: {
        ...action[RSAA].headers,
        ...headers,
      },
      endpoint,
    },
  };
  if (action.method === 'PUT' || action.method === 'POST') {
    req.body = action.body;
  }
  return next(req);
};

export default apiUrlMiddleware;
